import { Grid } from "@mui/material";
import { ReactNode } from "react";
import { Button } from "../ui/Button/Button";
import { Tooltip } from "../ui/Tooltip/Tooltip";
import { Typography } from "../ui/Typography/Typography";

export interface OptionItem {
  label: string;
  value: string;
  info?: string;
}

export interface PreferenceStepProps {
  title: string;
  description?: string;
  optionsTitle?: string;
  options: OptionItem[];
  selectedValues: string[];
  onOptionChange: (value: string) => void;
  renderButtons: () => ReactNode;
}

export const PreferenceStep = ({
  title,
  description,
  optionsTitle,
  options,
  selectedValues,
  onOptionChange,
  renderButtons,
}: PreferenceStepProps) => {
  return (
    <Grid container spacing={5} className="PreferenceStep">
      <Grid item sm={6} md={5} className="PreferenceStep__header">
        <Typography desktop="h1">{title}</Typography>
        {description && <Typography desktop="body1">{description}</Typography>}
      </Grid>
      <Grid item sm={6} md={7} className="PreferenceStep__content">
        <div>
          {optionsTitle && (
            <Typography
              desktop="body2"
              className="PreferenceStep__content__title"
            >
              {optionsTitle}
            </Typography>
          )}
          <div className="PreferenceStep__content__options">
            {options.map((option) => {
              const isSelected = selectedValues.includes(option.value);
              const renderButton = (
                <Button
                  variant={isSelected ? "contained" : "outlined"}
                  color="secondary"
                  onClick={() => onOptionChange(option.value)}
                  small
                  data-testid={`option-${option.value}`}
                >
                  {option.label}
                </Button>
              );

              return (
                <div
                  key={option.value}
                  className="PreferenceStep__content__option"
                >
                  {option.info ? (
                    <Tooltip
                      title={option.info}
                      cardContent={
                        <Typography desktop="body1" color="secondary">
                          {option.info}
                        </Typography>
                      }
                      arrow
                      placement="top"
                    >
                      <span>{renderButton}</span>
                    </Tooltip>
                  ) : (
                    renderButton
                  )}
                </div>
              );
            })}
          </div>
        </div>
        {renderButtons()}
      </Grid>
    </Grid>
  );
};
